var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H31C32.6569 0 34 1.34315 34 3V4H3C1.34315 4 0 2.65685 0 1V0Z",
    fill: "#1671EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10H35C36.6569 10 38 11.3431 38 13V14H7C5.34315 14 4 12.6569 4 11V10Z",
    fill: "#1671EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20H31C32.6569 20 34 21.3431 34 23V24H3C1.34315 24 0 22.6569 0 21V20Z",
    fill: "#1671EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ed84cfb1712a9cefa7a19434b162f57c.svg";
export { ForwardRef as ReactComponent };